import infoIcon from '@/assets/figma/login-info.svg';
import { cn } from '@/shared/lib/utils';

/** 웹에서 제공하지 않는 앱 전용 기능 (Figma 858:10349) */
const APP_ONLY_LINES = [
  '회원가입, 비밀번호 재설정',
  '사업자 정보 등록',
  '거래처, 필터링 신청',
  '판촉영업 위탁 계약 전자서명',
  '처방 분석, 맥스매치',
];

const card =
  'items-start gap-2 rounded-[20px] border-[1.5px] border-[#e5e7ea] bg-white p-4 text-[#131927]';

/**
 * 베타 안내 (Figma 833:7609). 마우스를 올리거나 포커스(모바일은 탭)하면
 * 앱 전용 기능 목록이 펼쳐진 안내(858:10349)로 바뀐다.
 */
export const BetaHelpText = ({ className }: { className?: string }) => (
  <div
    tabIndex={0}
    aria-label="루다링크 웹 베타 안내"
    className={cn('group z-10 outline-none', className)}
  >
    <div className={cn(card, 'flex group-focus:hidden group-hover:hidden')}>
      <img src={infoIcon} alt="" width={24} height={24} className="shrink-0" />
      <p className="text-sm leading-[22px] font-medium tracking-[-0.112px]">
        루다링크 웹은 아직 베타 버전이에요.
        <br />
        현재는 일부 기능만 이용할 수 있어요.
      </p>
    </div>

    <div className={cn(card, 'hidden group-focus:flex group-hover:flex')}>
      <img src={infoIcon} alt="" width={24} height={24} className="shrink-0" />
      <div className="tracking-[-0.112px]">
        <p className="text-sm leading-[22px] font-semibold">
          루다링크 웹은 현재는 일부 기능만 이용할 수 있어요.
          <br />
          아래 기능은 앱에서 이용해주세요.
        </p>
        <ul className="list-disc pl-5 text-[13px] leading-5 tracking-[-0.065px]">
          {APP_ONLY_LINES.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
